// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__n6WKm","main-image":"Header_main-image__3vQX0"};